// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cdf85560","453":"dc680808","455":"9682f7b0","977":"a6b9e35a"}[chunkId] + ".chunk.js";
};